import moment from "moment";

export const transactionTypes = {
  FinalBalance: { displayValue: "Saldo Final" },
  InitialBalance: { displayValue: "Saldo Inicial" },
  CreditPixIn: { displayValue: "Pix Recebido" },
  RatePixIn: { displayValue: "Taxa de Recebimento de Pix" },
  PreDebitPixOut: { 
    displayValue: "Pix Enviado",
    formatter: (data) => (data.isQrCode ? "Pagamento via Pix" : "Pix Enviado"), 
  },
  CreditRefundPixOut: { displayValue: "Devolução Pix", },
  PreDischargeAccount: { displayValue: "Transferência por TED", },
  PreDebitBoletoOut: { displayValue: "Pagamento de Boleto", },
  CreditTedIn: { displayValue: "Recebimento por TED", },
  RateTedIn: { displayValue: "Taxa de Recebimento de TED", },
  PreRateByPixOut: { displayValue: "taxa de Envio de Pix", },
  BoletoWithOverpaid: { displayValue :'Confirmação de pgto de boleto' },
  ChargeAccount: { displayValue :'Cobrança de Mensalidade' },
  chargeAccountChannel: { displayValue :'ChargeAccountChannel' },
  RateInternalDischargeAccount: { displayValue: "Taxa de Transferencia", },
  RateByBoleto: { displayValue: "Taxa de recebimento de boleto", },
  CreditBoleto: { displayValue: "Confirmação de pgto de boleto", },
  CancelRateTransferPIX: { displayValue :'Cancelamento da Taxa de PIX' },
  CancelRateTransfer: { displayValue :'Cancelamento da Taxa de TED' },

  "e-Check compensado": {
    displayValue: "e-Check compensado",
    formatter: (data) => `e-Check compensado - ${data.details ?? ""}`,
  },
  ChargeAccountChannel: {
    displayValue: "Cobrança de Mensalidade",
    formatter: (data) =>
      `Cobrança de mensalidade das contas isentadas referente ao mês de ${moment(
        data.date
      ).format("MMMM")}`,
  },
  FinancialCharge: { displayValue: "Cobrança de Multa" },
};